import { buildGlobalAction, buildInlineComputedView } from "./../builder.js";
class SharedNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the autoOptoutMailer global action. */
    this.autoOptoutMailer = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "autoOptoutMailer",
      operationName: "autoOptoutMailer",
      operationReturnType: "SharedAutoOptoutMailer",
      namespace: "shared",
      variables: {}
    });
    /** Executes the campaignExportHelpers global action. */
    this.campaignExportHelpers = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "campaignExportHelpers",
      operationName: "campaignExportHelpers",
      operationReturnType: "SharedCampaignExportHelpers",
      namespace: "shared",
      variables: {}
    });
    /** Executes the preventCrossCustomerAccess global action. */
    this.preventCrossCustomerAccess = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "preventCrossCustomerAccess",
      operationName: "preventCrossCustomerAccess",
      operationReturnType: "SharedPreventCrossCustomerAccess",
      namespace: "shared",
      variables: {}
    });
    /** Executes the sendMailReportExportStripe global action. */
    this.sendMailReportExportStripe = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "sendMailReportExportStripe",
      operationName: "sendMailReportExportStripe",
      operationReturnType: "SharedSendMailReportExportStripe",
      namespace: "shared",
      variables: {}
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: "shared",
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  SharedNamespace
};
//# sourceMappingURL=shared.js.map
